import { getAuthHeader, getError, header } from '../../shared/utils';
import {
  API_ADD_PLAN_PROGRAM,
  API_EDIT_PLAN_PROGRAM,
  API_DELETE_PLAN_PROGRAM,
  API_UPDATE_PLAN_PROGRAM_STATUS,
} from '../../shared/constant/url';

export const PLANPROGRAM = {
  ADD_START: 'ADD_START',
  ADD_SUCCESS: 'ADD_SUCCESS',
  ADD_ERROR: 'ADD_ERROR',

  DELETE_START: 'DELETE_START',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_ERROR: 'DELETE_ERROR',

  EDIT_START: 'EDIT_START',
  EDIT_SUCCESS: 'EDIT_SUCCESS',
  EDIT_ERROR: 'EDIT_ERROR',

  UPDATE_PLAN_PROGRAM_START: 'UPDATE_PLAN_PROGRAM_START',
  UPDATE_PLAN_PROGRAM_SUCCESS: 'UPDATE_PLAN_PROGRAM_SUCCESS',
  UPDATE_PLAN_PROGRAM_ERROR: 'UPDATE_PLAN_PROGRAM_ERROR',
};

export const addPlanRecord = (params, file, callback = null) => {
  return (dispatch) => {
    dispatch({ type: PLANPROGRAM.ADD_START });
    let formData = new FormData();
    formData.append('report_type', params.category);
    formData.append('date_submitted', params.date_submitted);
    formData.append('subject', params.subject);
    if (params.task_id) {
      formData.append('task_id', params.task_id);
    }
    if (file.length > 0) {
      for (let i = 0; i < file.length; i++) {
        formData.append(`file[${i}]`, file[i]);
      }
    }
    formData.append('description', params.description);

    let requestOptions = {
      method: 'POST',
      headers: getAuthHeader(),
      body: formData,
    };
    fetch(API_ADD_PLAN_PROGRAM, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        callback(response, null);
        dispatch({
          type: PLANPROGRAM.ADD_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(null, error);
        dispatch({
          type: PLANPROGRAM.ADD_ERROR,
          payload: getError(error),
        });
      });
  };
};
export const ArchiveAll = (params, callback = null) => {
  return (dispatch) => {
    dispatch({ type: PLANPROGRAM.ADD_START });
    let formData = new FormData();

    let requestOptions = {
      method: 'POST',
      headers: getAuthHeader(),
    };
    fetch(
      `${API_ADD_PLAN_PROGRAM}/archive?report_type=${
        params.report_type ? params.report_type : ''
      }&start_date=${params.start_date ? params.start_date : ''}&end_date=${
        params.end_date ? params.end_date : ''
      }`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((response) => {
        callback(response, null);
        dispatch({
          type: PLANPROGRAM.ADD_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(null, error);
        dispatch({
          type: PLANPROGRAM.ADD_ERROR,
          payload: getError(error),
        });
      });
  };
};
export const editPlanRecord = (params, file, id, callback = null) => {
  return (dispatch) => {
    dispatch({ type: PLANPROGRAM.EDIT_START });
    let formData = new FormData();
    if (params.category) {
      formData.append('report_type', params.category);
    }
    if (params.date_submitted) {
      formData.append('date_submitted', params.date_submitted);
    }
    if (params.subject) {
      formData.append('subject', params.subject);
    }
    if (params.description) {
      formData.append('description', params.description);
    }

    if (file.length > 0) {
      for (let i = 0; i < file.length; i++) {
        formData.append(`file[${i}]`, file[i]);
      }
    }

    formData.append('_method', 'PUT');

    let requestOptions = {
      method: 'POST',
      headers: getAuthHeader(),
      body: formData,
    };
    fetch(`${API_EDIT_PLAN_PROGRAM}${id}`, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        callback(response, null);
        dispatch({
          type: PLANPROGRAM.EDIT_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(null, error);
        dispatch({
          type: PLANPROGRAM.EDIT_ERROR,
          payload: getError(error),
        });
      });
  };
};

export const deletePlan = (params, callback = null) => {
  return (dispatch) => {
    dispatch({ type: PLANPROGRAM.DELETE_START });
    let requestOption = {
      method: 'DELETE',
      headers: getAuthHeader(),
    };
    fetch(`${API_DELETE_PLAN_PROGRAM}${params}`, requestOption)
      .then((response) => response.json())
      .then((response) => {
        callback(response);
        dispatch({
          type: PLANPROGRAM.DELETE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(error, getError(error));
        dispatch({ type: PLANPROGRAM.DELETE_ERROR, payload: error });
      });
  };
};

export const updatePlanStatus = (params, id, callback = null) => {
  return (dispatch) => {
    dispatch({ type: PLANPROGRAM.UPDATE_PLAN_PROGRAM_START });
    let data = JSON.stringify({ status: params.status });

    let requestOption = {
      method: 'PATCH',
      body: data,
      headers: header(),
    };
    fetch(`${API_UPDATE_PLAN_PROGRAM_STATUS}${id}/status`, requestOption)
      .then((response) => response.json())
      .then((response) => {
        callback(response);
        dispatch({
          type: PLANPROGRAM.UPDATE_PLAN_PROGRAM_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(error, getError(error));
        dispatch({
          type: PLANPROGRAM.UPDATE_PLAN_PROGRAM_ERROR,
          payload: error,
        });
      });
  };
};
